import React from 'react'
import { FilterContainer, FilterItem } from './Theme'

const Filter = ({filterList, selectedFilter, setSelectedFilter,onFilterChange}) => {

  const onFilterChangeHandler = (filter) => {
    if(onFilterChange) return onFilterChange(filter)
    setSelectedFilter(filter)
  }


  return (
    <FilterContainer>
      {filterList.map((filter, index) => (
        <FilterItem key={filter.value} onClick={() => onFilterChangeHandler(filter.value)} selected={selectedFilter === filter.value}>
          {filter.name}
        </FilterItem>
      ))}
    </FilterContainer>
  )
}

export default Filter